"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BrixelModal = _interopRequireDefault(require("./BrixelModal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BrixelModalConfirm = props => {
  const {
    cancel,
    confirm,
    icon = 'alert',
    lang,
    message,
    title,
    classTitle = ''
  } = props;
  return /*#__PURE__*/_react.default.createElement(_BrixelModal.default, {
    title: title,
    titleIcon: icon,
    color: "red",
    saturationTxt: 400,
    layout: "large",
    lang: lang,
    classTitle: classTitle,
    onClose: () => cancel(),
    multiActions: [{
      round: true,
      clr: 'red',
      btnType: 'Secondary',
      className: 'mr-1',
      name: 'Cancel',
      func: () => cancel()
    }, {
      round: true,
      clr: 'primary',
      name: 'Confirm',
      btnType: 'Primary',
      func: () => confirm()
    }],
    clickOutsideToClose: false
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }));
};
var _default = exports.default = BrixelModalConfirm;